import { FloatButton } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ChatbotPopover from '../components/ChatbotPopover';
import NextViewButton from "../components/NextViewButton";
import { useView } from "../contexts/ViewContext";
import FatalError from "./FatalError";
import Waiting from "./Waiting";
import { viewComponents } from "./viewComponents";

import { useChatbot } from "../contexts/ChatContext";

function LearningJourneySpace() {
    const navigate = useNavigate();
    const { view, error, learningJourneyId } = useView();
    const { showChatbot } = useChatbot();

    useEffect(() => {
        if (view && !viewComponents[view.view_type]) {
            navigate("/");
        }
    }, [view, navigate]);

    if (error) {
        let message = "";

        switch (error) {
            case 500:
                message =
                    "We’re having trouble connecting to our servers. " +
                    "Please try again later. " +
                    "If the issue persists, contact support.";
                break;
            case 404:
                message =
                    "The requested learning journey could not be found. " +
                    "Please contact support if this problem continues.";
                break;
            default:
                message =
                    "An unexpected error occurred. " +
                    "Please refresh the page or contact support if the problem persists.";
        }

        return <FatalError message={message} />;
    }


    if (!view || !view.view_type) {
        if (process.env.NODE_ENV === "development") {
            console.warn("View is unexpectedly null");
        }
        return <Waiting learningJourneyId={learningJourneyId} view={view} />;
    }

    const SpaceToRender = viewComponents[view.view_type];

    // Rendering an undefined component would throw before the redirect effect above runs.
    if (!SpaceToRender) return null;

    return (
        <div
            style={{
                display: "flex",
                flex: "0 0 auto",
                alignItems: "center",
                height: "100%",
                width: "100%",
                overflow: "hidden",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            <SpaceToRender learningJourneyId={learningJourneyId} view={view} />
            <FloatButton.Group>
                {showChatbot && <ChatbotPopover learningJourneyId={learningJourneyId} view={view} />}
                <NextViewButton />
            </FloatButton.Group>
        </div>
    );
}

export default LearningJourneySpace;
